// Seasons.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import "./HomePage.css";

const seasonData = [
  {
    year: "2023-2024",
    info: "Season info placeholder for 2023-2024.",
  },
  {
    year: "2024-2025",
    info: "Season info placeholder for 2024-2025.",
  },
  {
    year: "2025-2026",
    info: "Season info placeholder for 2025-2026.",
  },
];

const Seasons = () => {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <div className="homepage-container">
      <Navbar />

      <main className="main-content">
        <motion.section
          className="card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">📅 Seasons</h2>

          <div>
            {seasonData.map(({ year, info }, i) => (
              <div key={year} style={{ marginBottom: "1rem" }}>
                <button
                  onClick={() => toggleExpand(i)}
                  style={{
                    width: "100%",
                    padding: "0.8rem 1rem",
                    fontWeight: "700",
                    fontSize: "1.2rem",
                    background: "#282f8b",
                    color: "#00e5ff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    textAlign: "left",
                    userSelect: "none",
                  }}
                  aria-expanded={expanded === i}
                >
                  {year} {expanded === i ? "▲" : "▼"}
                </button>
                {expanded === i && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    transition={{ duration: 0.3 }}
                    style={{
                      padding: "1rem",
                      background: "rgba(255 255 255 / 0.05)",
                      borderRadius: "8px",
                      marginTop: "0.5rem",
                      color: "#c0d6e4",
                      userSelect: "text",
                    }}
                  >
                    {info}
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </motion.section>
      </main>

      <footer className="footer">Created by Nick Criss ⚡️</footer>
    </div>
  );
};

export default Seasons;
